const consulta_de_alunos_marcados = [
  {
    path: "/consulta-de-alunos-marcados",
    name: "consulta_de_alunos_marcados",
    meta: {
      breadCrumb: "Censo Escolar - Marcação de Alunos",
      allowedPermissions: ["marcacao_listar_quantidade_alunos"],
    },
    component: () =>
      import("@/views/ConsultaDeAlunosMarcados/ConsultaDeAlunosMarcados.vue"),
  },
  {
    path: "/consulta-de-alunos-marcados/:ano_matricula/:escola_id/:ensino_id/:fase_id/:turno",
    name: "consulta_de_alunos_marcados_detalhes",
    meta: {
      breadCrumb: "Censo Escolar - Marcação de Alunos",
      allowedPermissions: ["marcacao_listar_alunos"],
    },
    component: () =>
      import(
        "@/views/ConsultaDeAlunosMarcados/ConsultaDeAlunosMarcadosDetalhes.vue"
      ),
  },
];

export { consulta_de_alunos_marcados };
